export default "__VITE_ASSET__DS4a4uy9__"